export type ConsoleEnvironment = 'localhost' | 'devConsole' | 'stagingConsole' | 'prodConsole';

export interface ExternalRedirectHosts {
  localhost: string;
  devConsole: string;
  stagingConsole: string;
  prodConsole: string;
}

export interface ExternalRedirectRoute {
  match: (url: string) => boolean;
  hosts: ExternalRedirectHosts;
}

export const EXTERNAL_REDIRECT_ROUTES: ExternalRedirectRoute[] = [
  {
    match: (url) => url === '/mfg/invoicing' || url === '/tsp/invoicing',
    hosts: {
      localhost: 'http://localhost:5173',
      devConsole: 'https://dev-invoicing.freightfox.ai',
      stagingConsole: 'https://staging-invoicing.freightfox.ai',
      prodConsole: 'https://invoicing.freightfox.ai',
    },
  },
  {
    match: (url) =>
      url === '/mfg/counter-offer' ||
      url === '/tsp/counter-offer' ||
      url.includes('/mfg/spot-bids/bulk-spot-bids'),
    hosts: {
      localhost: 'http://localhost:3000',
      devConsole: 'https://dev-procurement.freightfox.ai',
      stagingConsole: 'https://staging-procurement.freightfox.ai',
      prodConsole: 'https://procurement.freightfox.ai',
    },
  },
  {
    match: (url) => url === '/mfg/indents' || url === '/tsp/indents',
    hosts: {
      localhost: 'http://localhost:3000',
      devConsole: 'https://dev-operations.freightfox.ai',
      stagingConsole: 'https://staging-operations.freightfox.ai',
      prodConsole: 'https://operations.freightfox.ai',
    },
  },
];

export function getConsoleEnvironment(originHost: string): ConsoleEnvironment | null {
  if (originHost.includes('localhost')) {
    return 'localhost';
  }
  if (originHost.includes('staging-console')) {
    return 'stagingConsole';
  }
  if (originHost.includes('dev-console')) {
    return 'devConsole';
  }
  if (originHost.includes('console')) {
    return 'prodConsole';
  }
  return null;
}

export function resolveExternalRedirectHost(
  url: string,
  originHost: string
): string | undefined {
  const environment = getConsoleEnvironment(originHost);
  if (!environment) {
    return undefined;
  }

  const route = EXTERNAL_REDIRECT_ROUTES.find(({ match }) => match(url));
  return route?.hosts[environment];
}
